import Vue from "vue";
import Vuex from "vuex";
import usuario from "./usuario";
import settings from "./settings";
import salesChannel from "./sales-channel";
import cardIssuer from "./card-issuer";
import system from "./system";
import merchantContractFiles from "./merchant-contract-files"
import invoicePayments from "./invoice-payment"

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    usuario,
    settings,
    salesChannel,
    cardIssuer,
    system,
    merchantContractFiles,
    invoicePayments
  },
  state: {},
  mutations: {},
  actions: {}
});
